import { ServiceBase } from "@app/shared";
import { ExportNetworkOutreachModel, NetworkOutreachEmbeddedModel } from "./models";

export default class OutreachService extends ServiceBase {

  public async postExportPractitionerReport(model: ExportNetworkOutreachModel): Promise<number> {
    return await this.makePost<number>(`exports/network-outreach/practitioner`, model);
  }

  public async postExportServiceLocationReport(model: ExportNetworkOutreachModel): Promise<number> {
    return await this.makePost<number>(`exports/network-outreach/serviceLocation`, model);
  }

  public async postExportPractitionerAtLocationReport(model: ExportNetworkOutreachModel): Promise<number> {
    return await this.makePost<number>(`exports/network-outreach/practitionerAtLocation`, model);
  }

  public async getNetworkOutreachConfiguration(): Promise<NetworkOutreachEmbeddedModel> {
    return await this.makeGet<NetworkOutreachEmbeddedModel>(`networkoutreach`);
  }
}